import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Background from "../asserts/pic.png";
import { authFetch } from "../auth";


const AddFlyPage = () => {
    const [formData, setFormData] = useState({
        windtunnel: "",
        country: "",
        city: "",
        comment: "",
        datetime: "",
        duration: "",
        hasTime: ""
    });

    const [flyCount, setFlyCount] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, files: Array.from(e.target.files) }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (flyCount > 1) {
            const confirmSave = window.confirm(
                `Вы собираетесь добавить ${flyCount} полетов.\nВсе введённые данные будут применены ко всем полетам.\nПродолжить?`
            );
            if (!confirmSave) return;
        }
        const data = new FormData();

        // Добавляем метаданные
        data.append("windtunnel", formData.windtunnel);
        data.append("country", formData.country);
        data.append("city", formData.city);
        data.append("comment", formData.comment);
        data.append("duration", formData.duration);
        data.append("hasTime", formData.hasTime);

        if (formData.datetime) {
            data.append("datetime", formData.datetime + ":00");
        }

        // });

        data.append("flyCount", flyCount);

        try {
            const res = await authFetch("/api/flydata/upload", {
                method: "POST",
                body: data,
            });

            if (res.ok) {
                navigate("/tunnel");
            } else {
                alert("Ошибка при загрузке");
            }
        } catch (err) {
            console.error(err);
            alert("Произошла ошибка при загрузке");
        }
    };

    const renderInput = ({ label, name, placeholder = "", icon = "✏️", type = "text" }) => (
        <div style={fieldStyle}>
            <label style={labelStyle}>
                {icon} {label}
            </label>
            <input
                type={type}
                name={name}
                placeholder={placeholder}
                value={formData[name]}
                onChange={handleChange}
                style={inputStyle}
            />
        </div>
    );

    const renderDatalistInput = ({ label, name, options, placeholder = "" }) => (
        <div style={fieldStyle}>
            <label style={labelStyle}>{label}</label>
            <input
                list={`${name}-list`}
                name={name}
                placeholder={placeholder}
                value={formData[name]}
                onChange={handleChange}
                style={inputStyle}
            />
            <datalist id={`${name}-list`}>{options.map((opt) => <option key={opt} value={opt} />)}</datalist>
        </div>
    );

    return (
        <>
            {/* Фиксированный фон */}
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundImage: `url(${Background})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    zIndex: -1,
                }}
            />

            {/* Контент */}
            <div
                style={{
                    minHeight: "100vh",
                    padding: isMobile ? "20px 12px" : "40px 20px",
                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    boxSizing: "border-box",
                }}
            >
                {/* ТВОЯ ФОРМА */}
                <form onSubmit={handleSubmit} style={formStyle}>
                    <h2 style={{ textAlign: "center", marginBottom: "30px", fontSize: "26px" }}>
                        🌀 Добавить новые сессии
                    </h2>

                    <fieldset style={sectionStyle}>
                        <legend style={legendStyle}>📍 Аэротруба</legend>
                        <div style={{ ...gridStyle, gridTemplateColumns: "repeat(3, 1fr)" }}>
                            {renderInput({ label: "Название", name: "windtunnel", icon: "🏁", placeholder: "Vacuum, iFly..." })}
                            {renderInput({ label: "Страна", name: "country", icon: "🌍", placeholder: "ОАЭ" })}
                            {renderInput({ label: "Город", name: "city", icon: "🏙️", placeholder: "Дубай" })}
                        </div>
                    </fieldset>

                    <fieldset style={sectionStyle}>
                        <legend style={legendStyle}>📝 Подробности полета</legend>
                        <div style={gridStyle}>

                            {renderInput({ label: "Комментарий", name: "comment", icon: "💬", placeholder: "заметки к полету" })}
                        </div>
                    </fieldset>

                    {/* === РУЧНОЙ ВВОД === */}
                    {/* {inputMode === "manual" && ( */}
                    <><fieldset style={sectionStyle}>
                        <legend style={legendStyle}>🔢 Количество сессий</legend>

                        <div style={gridStyle}>
                            <div style={fieldStyle}>
                                <label style={labelStyle}>Сколько полетов добавить?</label>
                                <input
                                    type="number"
                                    min="1"
                                    value={flyCount}
                                    onChange={(e) => setFlyCount(Number(e.target.value))}
                                    style={inputStyle} />
                            </div>
                        </div>
                    </fieldset>

                        {/* 👇 НОВЫЙ БЛОК ДАТЫ */}
                        <fieldset style={sectionStyle}>
                            <legend style={legendStyle}>📅 Дата и время полета</legend>

                            <div style={gridStyle}>
                                <div style={fieldStyle}>
                                    <label style={labelStyle}>Дата и время</label>
                                    <input
                                        type="datetime-local"
                                        name="datetime"
                                        min="2000-01-01T00:00"
                                        max="2099-12-31T23:59"
                                        value={formData.datetime}
                                        onChange={handleChange}
                                        style={{
                                            ...inputStyle,
                                            padding: "9px",
                                        }}
                                    />
                                </div>
                            </div>
                        </fieldset>

                        <fieldset style={sectionStyle}>
                            <legend style={legendStyle}>📐 Параметры полета</legend>

                            <div style={gridStyle}>
                                {renderInput({
                                    label: "Продолжительность полетной сессии (мин)",
                                    name: "duration",
                                    type: "number",
                                    placeholder: "1000"
                                })}

                                {renderInput({
                                    label: "Оставшееся после полета время депозита (мин)",
                                    name: "hasTime",
                                    type: "number",
                                    placeholder: "55"
                                })}
                            </div>
                        </fieldset>
                    </>


                    <button type="submit" style={buttonStyle}>📤 Сохранить</button>
                    <button type="button" onClick={() => navigate("/")} style={buttonStyle}>⬅️ На главную</button>
                </form>


            </div>
        </>
    );
};

// === Стили ===
const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px",
};

const sectionStyle = {
    border: "1px solid #444",
    borderRadius: "10px",
    padding: "20px",
    marginBottom: "25px",
};

const legendStyle = {
    fontWeight: "bold",
    padding: "0 10px",
    fontSize: "18px",
};

const labelStyle = {
    display: "block",
    marginBottom: "6px",
    fontWeight: "bold",
};

const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1.8px solid #444",
    outline: "none",
    backgroundColor: "#171d4b", // фон ввода текста
    color: "#eee",
    fontSize: "15px",
    fontWeight: "500",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    transition: "border-color 0.25s ease, box-shadow 0.25s ease",
    boxShadow: "inset 0 0 6px #000000cc",
    caretColor: "#FFD700",
    boxSizing: "border-box",
};

const fieldStyle = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#57438fd5", // фон полей
    padding: "10px 14px",
    borderRadius: "12px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.7)",
};

const formStyle = {
    backgroundColor: "rgba(42, 18, 99, 0.69)", // общий фон рамки.
    borderRadius: "16px",
    padding: "40px 30px",
    maxWidth: "1000px",
    width: "100%",
    boxShadow: "0 8px 30px rgba(0,0,0,0.85)",
    boxSizing: "border-box",
};

const buttonStyle = {
    width: "100%",
    backgroundColor: "#6a85ddde",  // цвет кнопок
    color: "#000",
    padding: "14px",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background 0.3s",
    marginBottom: "15px",
};

const modeButtonStyle = {
    flex: 1,
    padding: "12px",
    borderRadius: "10px",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "bold"
};

export default AddFlyPage;
